module.exports = __webpack_public_path__ + "post-listing-block-2-overlay@2x-1WPFU66.png";